import React from 'react';

export const TermsOfUsePage = () => (
    <div className="space-y-6">
        <h2 className="page-title heading-primary-1">Terms of Use</h2>
        <p className="text-center text-muted">Last updated: April 24, 2026</p>

        <div className="card p-6 rounded-lg shadow-md space-y-4">
            <p className="text-strong">
                Please read these Terms of Use ("Terms") carefully before using the Chico Area Dart Association (CADA) website (the "Service"). Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms.
            </p>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">1. Accounts</h3>
                <p>
                    When you create an account with us, you must provide information that is accurate, complete, and current at all times. You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password. You agree not to disclose your password to any third party.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">2. User Conduct</h3>
                <p>As a user of the Site, you agree not to:</p>
                <ul className="list-disc list-inside space-y-1 pl-4 text-muted">
                    <li>Systematically retrieve data or other content from the Site to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.</li>
                    <li>Engage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.</li>
                    <li>Interfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.</li>
                    <li>Attempt to impersonate another user or person.</li>
                    <li>Use any information obtained from the Site in order to harass, abuse, or harm another person.</li>
                </ul>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">3. Intellectual Property</h3>
                <p>
                    The Service and its original content (excluding Content provided by users), features, and functionality are and will remain the exclusive property of the Chico Area Dart Association. This includes all software, statistical data, and generated schedules.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">4. Disclaimers</h3>
                <p>
                    The Service is provided on an "AS IS" and "AS AVAILABLE" basis. While we strive for accuracy, we do not warrant that match results, statistics, or other data will be free of errors. The league administrators reserve the right to correct any data inaccuracies.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">5. Limitation of Liability</h3>
                <p>
                    In no event shall the Chico Area Dart Association, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">6. Termination</h3>
                <p>
                    We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">7. Changes to Terms</h3>
                <p>
                    We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice of any changes by posting the new Terms of Use on this page.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">8. Contact Us</h3>
                <p>
                    If you have any questions about these Terms, please contact us at: <a href="mailto:chicodarts530@gmail.com" className="text-info font-semibold hover:underline">chicodarts530@gmail.com</a>
                </p>
            </section>
        </div>
    </div>
);